import { render } from "./GoogleFontPickerModal.vue?vue&type=template&id=38f3dce0&scoped=true"
import script from "./GoogleFontPickerModal.vue?vue&type=script&lang=ts"
export * from "./GoogleFontPickerModal.vue?vue&type=script&lang=ts"

import "./GoogleFontPickerModal.vue?vue&type=style&index=0&id=38f3dce0&lang=scss"
import "./GoogleFontPickerModal.vue?vue&type=style&index=1&id=38f3dce0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-38f3dce0"

export default script